import { render, staticRenderFns } from "./RevisionCodigos.vue?vue&type=template&id=5fb30120&scoped=true"
import script from "./RevisionCodigos.vue?vue&type=script&lang=js"
export * from "./RevisionCodigos.vue?vue&type=script&lang=js"
import style0 from "./RevisionCodigos.vue?vue&type=style&index=0&id=5fb30120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb30120",
  null
  
)

export default component.exports